import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../../../../../../store/global-selectors';
import PropTypes from 'prop-types';
import { DimensionInput } from 'ui-components/components/dimension-input';
import InputValueProps from '../../../../../prop-types/input-value-props';
import UnexpectedValueComponent from './unexpected-value';
import { getDimensionsUnitEnum } from '../../../../../../../../services/unit-services/dimensions/dimension-unit-enum-resolver';
import { convertDimensions } from '../../../../../../../../services/unit-services/dimensions/dimension-convert-service';
import classnames from 'classnames';
import {
  SetDimensionUnitOfMeasureInch,
  SetDimensionUnitOfMeasureCentimeter,
} from '../../../../../../../../enums/set-package-dimensions-unit-of-measure';
import { DimensionUnit } from '../../../../../../../../enums/dimension-unit';

import { INT_PARAMETER, PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from './style.module.less';

const SetPackageDimensions = ({ inputValueProps, onChange, label }) => {
  const { [PARAMETER]: parameter, [INT_PARAMETER]: intParameter } = inputValueProps;
  const isNewAction = parameter === undefined;
  const valueParts = parameter?.toString().split('x') || [];
  const valueDoesNotConformToStandard = !isNewAction && valueParts.length !== 3;
  const sellerDefaultDimensionsUnit = useSelector(Global.selectSellerDefaultDimensionUnit);
  const unitToUseForNewRule = useMemo(() => {
    return sellerDefaultDimensionsUnit === DimensionUnit.Centimeters ? SetDimensionUnitOfMeasureCentimeter : SetDimensionUnitOfMeasureInch;
  }, [sellerDefaultDimensionsUnit]);

  const unitFromInputParams = getDimensionsUnitEnum(intParameter) ?? sellerDefaultDimensionsUnit ?? DimensionUnit.Inches;

  const dims = {
    length: Number.parseFloat(valueParts[0], 10),
    width: Number.parseFloat(valueParts[1], 10),
    height: Number.parseFloat(valueParts[2], 10),
    unit: unitFromInputParams,
  };

  const convertedDimensions = convertDimensions(dims, sellerDefaultDimensionsUnit);

  const setActionValue = useCallback(
    (dimensions) => {
      onChange({
        [PARAMETER]: `${dimensions?.length}x${dimensions?.width}x${dimensions?.height}`,
        [INT_PARAMETER]: intParameter || unitToUseForNewRule,
      });
    },
    [onChange, intParameter, unitToUseForNewRule],
  );
  if (valueDoesNotConformToStandard) {
    return <UnexpectedValueComponent />;
  }
  return (
    <div className={classnames(style['set-package-dimensions'], style['multi-control-row'])}>
      <div>{label}</div>
      <DimensionInput dimensions={convertedDimensions} onChange={setActionValue} unit={convertedDimensions.unit} />
    </div>
  );
};

SetPackageDimensions.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default SetPackageDimensions;
